export default function DustMonitoring() {
  const dustData = [
    { id: 'DUST001', location: '煤炭码头A区', concentration: '180μg/m³', threshold: '150μg/m³', status: '超标', wetOperation: '未执行', time: '2024-01-15 08:30' },
    { id: 'DUST002', location: '矿石码头B区', concentration: '95μg/m³', threshold: '150μg/m³', status: '正常', wetOperation: '执行中', time: '2024-01-15 09:15' },
    { id: 'DUST003', location: '散货堆场C区', concentration: '220μg/m³', threshold: '150μg/m³', status: '严重超标', wetOperation: '未执行', time: '2024-01-15 10:00' },
    { id: 'DUST004', location: '煤炭码头D区', concentration: '130μg/m³', threshold: '150μg/m³', status: '正常', wetOperation: '执行中', time: '2024-01-15 11:20' },
    { id: 'DUST005', location: '矿石堆场E区', concentration: '165μg/m³', threshold: '150μg/m³', status: '超标', wetOperation: '未执行', time: '2024-01-15 14:45' },
  ];

  const supervisionRecords = [
    { id: 'SUP001', location: '煤炭码头A区', issue: '未执行湿法作业', supervisionTime: '2024-01-15 08:35', handler: '张三', status: '已督促', result: '已整改' },
    { id: 'SUP002', location: '散货堆场C区', issue: '未执行湿法作业', supervisionTime: '2024-01-15 10:05', handler: '李四', status: '已督促', result: '整改中' },
    { id: 'SUP003', location: '矿石堆场E区', issue: '未执行湿法作业', supervisionTime: '2024-01-15 14:50', handler: '王五', status: '已督促', result: '待整改' },
  ];

  return (
    <div className="space-y-6">
      {/* 统计卡片 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">监测点位</span>
            <i className="ri-map-pin-line text-2xl text-teal-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">18</div>
          <div className="text-xs text-teal-400">全港覆盖</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">超标点位</span>
            <i className="ri-alert-line text-2xl text-orange-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">3</div>
          <div className="text-xs text-orange-400">需立即处理</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">平均浓度</span>
            <i className="ri-line-chart-line text-2xl text-blue-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">138μg/m³</div>
          <div className="text-xs text-green-400">低于阈值</div>
        </div>

        <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-400">湿法作业率</span>
            <i className="ri-water-percent-line text-2xl text-green-400"></i>
          </div>
          <div className="text-3xl font-bold text-white mb-1">83.3%</div>
          <div className="text-xs text-green-400">执行中</div>
        </div>
      </div>

      {/* 实时监测画面 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-camera-line text-teal-400"></i>
          实时监测画面
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://public.readdy.ai/ai/img_res/56fbc0b716470ca4b2260edef139829b.jpg"
              alt="粉尘超标"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">煤炭码头A区粉尘超标</div>
              <div className="text-red-400 text-xs">180μg/m³ - 未执行湿法作业</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=ore%20terminal%20with%20water%20spray%20dust%20suppression%20system%20in%20operation%2C%20wet%20method%20dust%20control%2C%20professional%20industrial%20photography%2C%20clear%20view%20of%20water%20mist%20spraying%20over%20cargo%20area%2C%20effective%20environmental%20protection%20measures%2C%20bright%20daylight&width=600&height=400&seq=dust-monitor-002&orientation=landscape"
              alt="湿法作业"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">矿石码头B区湿法作业</div>
              <div className="text-green-400 text-xs">95μg/m³ - 执行中</div>
            </div>
          </div>
          <div className="relative rounded-lg overflow-hidden h-48">
            <img 
              src="https://readdy.ai/api/search-image?query=bulk%20cargo%20storage%20yard%20with%20severe%20dust%20pollution%2C%20massive%20dust%20clouds%20visible%2C%20environmental%20hazard%20situation%2C%20aerial%20drone%20monitoring%20view%2C%20industrial%20port%20facility%2C%20urgent%20dust%20control%20needed%2C%20clear%20documentation%20of%20pollution&width=600&height=400&seq=dust-monitor-003&orientation=landscape"
              alt="严重超标"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
              <div className="text-white text-sm font-medium">散货堆场C区严重超标</div>
              <div className="text-red-400 text-xs">220μg/m³ - 紧急处理</div>
            </div>
          </div>
        </div>
      </div>

      {/* 粉尘浓度数据 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-file-list-line text-teal-400"></i>
          实时粉尘浓度数据
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">监测编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">监测位置</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">实时浓度</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">阈值</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">湿法作业</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">监测时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {dustData.map((data) => (
                <tr key={data.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{data.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{data.location}</td>
                  <td className="py-3 px-4 text-sm">
                    <span className={`font-medium ${
                      data.status === '正常' ? 'text-green-400' :
                      data.status === '超标' ? 'text-orange-400' :
                      'text-red-400'
                    }`}>
                      {data.concentration}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{data.threshold}</td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      data.status === '正常' ? 'bg-green-500/20 text-green-400' :
                      data.status === '超标' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {data.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      data.wetOperation === '执行中' ? 'bg-blue-500/20 text-blue-400' :
                      'bg-red-500/20 text-red-400'
                    }`}>
                      {data.wetOperation}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-sm text-gray-300">{data.time}</td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 督促记录 */}
      <div className="bg-gray-800/50 backdrop-blur-sm rounded-lg p-6 border border-teal-500/20">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <i className="ri-notification-line text-orange-400"></i>
          湿法作业督促记录
        </h3>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-700">
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">督促编号</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">位置</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">问题描述</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">督促时间</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">处理人</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">督促状态</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">整改结果</th>
                <th className="text-left py-3 px-4 text-sm font-medium text-gray-400">操作</th>
              </tr>
            </thead>
            <tbody>
              {supervisionRecords.map((record) => (
                <tr key={record.id} className="border-b border-gray-700/50 hover:bg-gray-700/30 transition-colors">
                  <td className="py-3 px-4 text-sm text-white">{record.id}</td>
                  <td className="py-3 px-4 text-sm text-white">{record.location}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.issue}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.supervisionTime}</td>
                  <td className="py-3 px-4 text-sm text-gray-300">{record.handler}</td>
                  <td className="py-3 px-4">
                    <span className="px-3 py-1 rounded-full text-xs font-medium bg-blue-500/20 text-blue-400">
                      {record.status}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                      record.result === '已整改' ? 'bg-green-500/20 text-green-400' :
                      record.result === '整改中' ? 'bg-orange-500/20 text-orange-400' :
                      'bg-yellow-500/20 text-yellow-400'
                    }`}>
                      {record.result}
                    </span>
                  </td>
                  <td className="py-3 px-4">
                    <button className="text-teal-400 hover:text-teal-300 text-sm cursor-pointer whitespace-nowrap">
                      查看详情
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}